import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import { Autocomplete, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";

const StudioSelector = ({ formik }) => {
  const [selectedStudio, setSelectedStudio] = useState([]);

  const productionCompanies = useSelector(
    (state) => state.contentForm.productionCompanies
  );

  const handleChange = (event, value) => {
    setSelectedStudio(value || []); // Store the full objects or strings
    
    // Handle both objects (from dropdown) and strings (manually entered)
    const selectedNames = value ? value.map((studio) => 
      typeof studio === 'string' ? studio : studio.name
    ) : [];
    
    formik.setFieldValue("studios", selectedNames);
  };

  console.log(selectedStudio, "selectedStudio");

  return (
    <Box>
      <Box sx={{ margin: "10px 0" }}>
        <label style={{ margin: "10px 0" }} htmlFor="licensing-region">
          Select Studios
          <span style={{ color: "red", marginLeft: "5px" }}>*</span>
        </label>
      </Box>
      <Autocomplete
        onChange={handleChange}
        multiple
        freeSolo
        value={selectedStudio || []}
        options={productionCompanies || []}
        sx={{ marginY: "10px" }}
        getOptionLabel={(option) => {
          // Handle both string values (manually entered) and objects (from options)
          return typeof option === 'string' ? option : option.name;
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
              {...optionProps}
            >
              {option?.name} ({option?.origin_country})
              {/* <img
                style={{ marginLeft: "auto" }}
                src={option.Poster}
                width={50}
                alt=""
              /> */}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Studios"
            variant="outlined"
          />
        )}
      />
    </Box>
  );
};

export default StudioSelector;